import React, { FC } from 'react';

import Icon from '../../../Icon';

import { IListNewsControl } from './interfaces';

import './styles.scss';

// list news control
const ListNewsControl: FC<IListNewsControl> = ({
  className = '',
  currentSlide = 0,
  onClick,
  slideCount = 0,
  type,
}) => {
  // react-slick adds `slick-disabled` when the stripe can't move further
  const disabled =
    className.indexOf('slick-disabled') !== -1 ||
    (type === 'left' ? currentSlide <= 0 : false) ||
    !onClick;

  // render
  return (
    <button
      className={`btn list-news-control-button ${type}`}
      data-disabled={disabled}
      onClick={onClick}>
      <Icon className={type} icon="icon-arrow-dg" />
    </button>
  );
};

export default ListNewsControl;